import { Navigate } from 'react-router-dom'

// Ruta de cortesía: /settings → /settings/profile.
export default function Settings() {
  return <Navigate to="/settings/profile" replace />
}
